module.exports = __webpack_public_path__ + "img/history.3e38a21e.png";